import React from 'react';
import PropTypes from 'prop-types';
import HorizontalScroll from '../Global/Containers/HorizontalScroll';
import TileLink from '../Global/Links/TileLink';

const PopularSearches = ({ presetSearches, active }) => {
  const listWrapperClass = `d-block faux-list`;
  const listClass = `popular-searches__list-item d-inline-block overflow-hidden m-b-0`;
  
  let customTiles;
  if (active === true) {
    customTiles = (
      <ul className={listWrapperClass}>
        {presetSearches.map((item) => {
          const { id, term, primary_filter: filter, image, display_text: displayText } = item;

          let hrefString = `/search?term=${term}&primaryFilter=${filter}&spellcheckEnabled=false`;
          if (term === `None`) {
            hrefString = `/search?primaryFilter=${filter}&spellcheckEnabled=false`;
          } else if (filter === `None`) {
            hrefString = `/search?term=${term}&spellcheckEnabled=false`;
          }

          let imgUrl;
          if (image.data.url) {
            imgUrl = image.data.url;
          }

          return <li className={listClass} key={id}><TileLink href={hrefString} imageUrl={imgUrl}>{displayText}</TileLink></li>;
        })}
      </ul>
    );
  // Needs to compared to false or null as the API will default to 'null' if the active dropdown in the CMS has not been explicitly set to 'false' before
  } else if (active === false || active === null) {
    customTiles = (
      <ul className={listWrapperClass}>
        <li className={listClass}><TileLink href="/search?term=pre season&primaryFilter=practice" imageUrl="https://storage.googleapis.com/tcm-coachingmanual-v3.appspot.com/training-ground/popular-searches/pre-season.jpg">Pre-season</TileLink></li>
        <li className={listClass}><TileLink href="/search?primaryFilter=session" imageUrl="https://storage.googleapis.com/tcm-coachingmanual-v3.appspot.com/training-ground/popular-searches/sessions.jpg">Full Sessions</TileLink></li>
        <li className={listClass}><TileLink href="/search?primaryFilter=practice" imageUrl="https://storage.googleapis.com/tcm-coachingmanual-v3.appspot.com/training-ground/popular-searches/practices.jpg">Practices</TileLink></li>
        {/* <li className={listClass}><TileLink href="/search?primaryFilter=practices" imageUrl="https://storage.googleapis.com/tcm-coachingmanual-v3.appspot.com/training-ground/popular-searches/videos.jpg">Coaching Videos</TileLink></li> */}
        <li className={listClass}><TileLink href="/search?primaryFilter=guide" imageUrl="https://storage.googleapis.com/tcm-coachingmanual-v3.appspot.com/training-ground/popular-searches/guides.jpg">Guides</TileLink></li>
        <li className={listClass}><TileLink href="/search?primaryFilter=education" imageUrl="https://storage.googleapis.com/tcm-coachingmanual-v3.appspot.com/training-ground/popular-searches/player-education.jpg">Player Education</TileLink></li>
        {/* <li className={listClass}><TileLink href="/search?primaryFilter=sessions" imageUrl="https://storage.googleapis.com/tcm-coachingmanual-v3.appspot.com/training-ground/popular-searches/tactics.jpg">Tactics</TileLink></li> */}
        <li className={listClass}><TileLink href="/search?term=goalkeeping&primaryFilter=practice" imageUrl="https://storage.googleapis.com/tcm-coachingmanual-v3.appspot.com/training-ground/popular-searches/goalkeeping.jpg">Goalkeeping Practices</TileLink></li>
        <li className={listClass}><TileLink href="/search?term=1 to 1&primaryFilter=practice" imageUrl="https://storage.googleapis.com/tcm-coachingmanual-v3.appspot.com/training-ground/popular-searches/1-to-1-practices.jpg">1 to 1 Practices</TileLink></li>
        <li className={listClass}><TileLink href="/search?primaryFilter=podcast" imageUrl="https://storage.googleapis.com/tcm-coachingmanual-v3.appspot.com/training-ground/popular-searches/podcasts.jpg">Podcasts</TileLink></li>
        <li className={listClass}><TileLink href="/search?term=infographic&primaryFilter=education" imageUrl="https://storage.googleapis.com/tcm-coachingmanual-v3.appspot.com/training-ground/popular-searches/infographics.jpg">Infographics</TileLink></li>
      </ul>
    );
  }

  return (
    <div className="popular-searches p-x-3 text-center">
      {customTiles && (
        <HorizontalScroll constant>
          {customTiles}
        </HorizontalScroll>
      )}
    </div>
  );
};

PopularSearches.propTypes = {
  active: PropTypes.bool,
  presetSearches: PropTypes.array,
};

export default PopularSearches;


// WEBPACK FOOTER //
// ./library/app/components/TrainingGround/PopularSearches.js